// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__1CD_F","rootCenter":"LoadMoreObserver_rootCenter__NneeF","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__2jqO4"};